import React from 'react';
import { Button } from '@/components/ui/button';
import { downloadBlob } from '@/lib/download';
import { isTeam } from '@/lib/role';
export const ExportCSVButton = ({ filename, workspace, request }) => {
    if (!isTeam(workspace))
        return null;
    const onClick = async () => {
        const res = await request();
        downloadBlob(res.data, filename);
    };
    return (<Button size="sm" variant="outline" onClick={onClick}>
            Export CSV
        </Button>);
};
